import { BillingReportResponse } from "../../Models/Billing";
import api from "../axios";

export const billingService = {
  getReport: async (params: { startDate?: string; endDate?: string; page?: number; pageSize?: number; orderSource?: number }): Promise<BillingReportResponse> => {
    const response = await api.get("/billing", { params });
    return response.data;
  }
};
